import { SidebarSearchField } from '@/components/ui/TextField/SidebarSearchField'
import { Stack } from '@mui/material'

import type React from 'react'
import { useEffect, useState, useCallback, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useDebounce } from 'use-debounce'

import { useGmFiltersActions, useGmFiltersState } from '../../store/gmFiltersStore'

const MenuItemSearch = () => {
  const { initialised, itemName } = useGmFiltersState()
  const { setItemName } = useGmFiltersActions()
  const [input, setInput] = useState('')
  const [debouncedInput] = useDebounce(input, 500)
  const [initializedFromStore, setInitializedFromStore] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    if (initialised && !initializedFromStore) {
      setInput(itemName || '')
      setInitializedFromStore(true)
    }
  }, [itemName, initialised, initializedFromStore])

  const filterActionsRef = useRef(setItemName)
  filterActionsRef.current = setItemName

  useEffect(() => {
    if (!initialised || !initializedFromStore) return

    filterActionsRef.current(debouncedInput)
  }, [debouncedInput, initialised, initializedFromStore])

  const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setInput(e.target.value)
  }, [])

  return (
    <Stack spacing={1} direction="column">
      <SidebarSearchField
        id="menu-item-search"
        placeholder={t('marketplace:searchForItems')}
        onChange={handleInputChange}
        value={input}
      />
    </Stack>
  )
}

export default MenuItemSearch
export { MenuItemSearch }
